import React, { useState } from "react"
import { FormattedMessage } from "gatsby-plugin-intl"
import axios from "axios";
import swal from 'sweetalert';

const Form = () => {
  const blockStyle = "mb-6 md:mb-10"
  const labelStyle =
    "dark:text-secondary uppercase text-gray-800 font-bold text-xl font-header "
  const inputStyle =
    "w-full px-3 py-3 mt-2 text-lg text-gray-800 dark:bg-white border rounded border-primary_light focus:border focus:border-primary focus:outline-none font-body bg-gray-100"

  const [serverState, setServerState] = useState({
    submitting: false,
    status: null
  });
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg }
    });
    if (ok) {
      form.reset();
      swal("Success", "Message delivered successfully, i will reply to your message as soon as possible", "success");
    }
  };
  const handleOnSubmit = e => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });
    axios({
      method: "post",
      url: "https://getform.io/f/619fd414-0ccd-49a9-b849-f08f77c0b735",
      data: new FormData(form)
    })
      .then(r => {
        handleServerResponse(true, "Thanks!", form);
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  return (
    <form
      onSubmit={handleOnSubmit}
      id="contactForm"
    >
      <input type="hidden" name="contact" value="contact" />

      <div className="flex flex-col md:flex-row">
        <div className={blockStyle + "w-full md:w-1/2 md:mr-6"}>
          <label className={labelStyle} htmlFor="firstname">
            <FormattedMessage id="form.firstname" />
            <input
              type="text"
              id="firstname"
              name="firstname"
              className={inputStyle}
              placeholder="Sena"
              required
            />
          </label>
        </div>

        <div className={blockStyle + "w-full md:w-1/2"}>
          <label className={labelStyle} htmlFor="lastname">
            <FormattedMessage id="form.lastname" />
            <input
              type="text"
              id="lastname"
              name="lastname"
              className={inputStyle}
              placeholder="Kobayakawa"
              required
            />
          </label>
        </div>
      </div>

      <div className={blockStyle}>
        <label className={labelStyle} htmlFor="email">
          <FormattedMessage id="form.email" />
          <input
            type="email"
            id="email"
            name="email"
            className={inputStyle}
            placeholder="s.kobayakawa@devilbats.jp"
            required
          />
        </label>
      </div>

      <div className={blockStyle}>
        <label className={labelStyle}>
          <FormattedMessage id="form.message" />
          <textarea
            name="message"
            className={inputStyle}
            rows="8"
            required
          ></textarea>
        </label>
      </div>

      <div className="flex justify-center">
        <button
          type="submit"
          className="px-12 py-2 mt-6 text-xl font-bold text-center text-white uppercase rounded-full cursor-pointer font-header bg-primary hover:bg-primary md:text-1xl dark:bg-secondary dark:text-secondary_dark dark:hover:bg-secondary_light"
          aria-label="Send an email"
        >
          <FormattedMessage id="form.send" />
        </button>
      </div>
    </form>
  )
}

export default Form
